import { PlayerInfo } from '@/screens/authenticated/types';
import { PlayerPosition } from './in-room-player-list';
import { MotionProps } from 'framer-motion';
import { remToPx } from '../../hooks';

export function dividePlayers(players: PlayerInfo[]) {
  const totalPlayers = players.length;

  // Special-case the 1-vs-1 layout: the single opponent should sit at the
  // top of the table, directly facing the local player whose deck is
  // anchored to the bottom. Without this the old proportional split sent
  // the only opponent to the side, which looked off (one on top, one on
  // the side for a 2-player match).
  if (totalPlayers === 1) {
    return [players, [], []];
  }

  const firstCount = Math.round(totalPlayers * 0.5);
  const secondCount = Math.round(totalPlayers * 0.25);

  const firstPlayers = players.slice(0, firstCount);
  const secondPlayers = players.slice(firstCount, firstCount + secondCount);
  const thirdPlayers = players.slice(firstCount + secondCount);

  return [firstPlayers, thirdPlayers.reverse(), secondPlayers];
}

export function otherPlayerCardAnimation(
  id: string,
  playerPos: PlayerPosition[],
  isMd: boolean,
  placement?: 'left' | 'right'
) {
  const player = playerPos.find(player => player.id === id);
  if (!player) return undefined;

  const isHorizontal = player.isHorizontal;
  const pxY = isMd ? 6 : 12;
  const px = isMd ? 10 : 15;
  const animateLeft = {
    x: remToPx(px),
    y: 0,
    rotate: 360,
  };

  const animateRight = {
    x: -remToPx(px),
    y: 0,
    rotate: -360,
  };

  const animateHorizontal = {
    x: 0,
    y: remToPx(pxY),
    rotate: 360,
  };

  let animate = {};
  if (placement === 'left') {
    animate = animateLeft;
  } else if (placement === 'right') {
    animate = animateRight;
  } else if (isHorizontal) {
    animate = animateHorizontal;
  }

  const motionProps: MotionProps = {
    style: {
      position: 'fixed',
      top: player.top,
      left: player.left,
      pointerEvents: 'none',
    },
    animate: {
      ...animate,
      transition: { duration: 0.6 },
    },
    initial: { y: 0, rotate: 0 },
  };

  return motionProps;
}
